module.exports = "/_next/static/images/analytics-duotone-06b00cc00ccd2fed4268989bbb0b63ee.svg";